// engine
import { ArController } from '@aceroll/core';

export class ServerFail extends ArController {
    onStart() {

    }
}